import React, {
  createContext,
  useContext,
  useState
} from "react";

const StoredDetails = createContext(null);

export const AuthProvider = ({
  children
}) => {

  const [authData, setAuthData] = useState({
    user: null,
    locations: [],
    selectedLocation: null,
    notificationCount: 0
  });

  const setUserData = (userData) => {

    setAuthData((prev) => ({
      ...prev,
      user: userData
    }));

  };

  const setLocations = (locations) => {

    setAuthData((prev) => ({
      ...prev,
      locations: locations || []
    }));

  };

  const setSelectedLocation = (
    location
  ) => {

    setAuthData((prev) => ({
      ...prev,
      selectedLocation: location
    }));

  };

  const setNotificationCount = (count) => {

    setAuthData((prev) => ({
      ...prev,
      notificationCount: Number.isFinite(Number(count)) ? Number(count) : 0
    }));

  };

  const logout = () => {

    setAuthData({
      user: null,
      locations: [],
      selectedLocation: null,
      notificationCount: 0
    });

    sessionStorage.clear();

    localStorage.removeItem(
      "rememberedCredentials"
    );

  };

  return (
    <StoredDetails.Provider
      value={{
        authData,

        setUserData,

        setLocations,

        setSelectedLocation,

        setNotificationCount,

        notificationCount: authData?.notificationCount ?? 0,

        logout
      }}
    >
      {children}
    </StoredDetails.Provider>
  );
};

export const useAuth = () => {

  const context =
    useContext(StoredDetails);

  if (!context) {
    throw new Error(
      "useAuth must be used inside AuthProvider"
    );
  }

  return context;
};